import axios from 'axios';
import { useEffect, useMemo, useState } from 'react';
import { MAIN_URL } from '../api';
import { useClickOutside } from './useClickOutside';
import { useScrollLock } from './useScrollLock';
import { useStores } from './useStores';
import { useCountdown } from './useCountdown';

axios.defaults.baseURL = `${MAIN_URL}/api/v1/`;
const useAxios = (axiosParams) => {
  const { url } = axiosParams;
  const [response, setResponse] = useState(undefined);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  let headers = {};
  if (localStorage.getItem('tokenData')) {
    let token = `Token ${localStorage.getItem('tokenData')}`;
    headers = { Authorization: token };
  }

  useEffect(() => {
    fetchData(axiosParams);
  }, [url]);

  const fetchData = async (params) => {
    setLoading(true);
    try {
      const result = await axios.request({ headers, ...params });
      setResponse(result.data);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  return { response, error, loading };
};

const useOnScreen = (ref, optional = {}) => {
  const [isIntersecting, setIntersecting] = useState(false);

  const observer = useMemo(
    () =>
      new IntersectionObserver(
        ([entry]) => setIntersecting(entry.isIntersecting),
        optional,
      ),
    [ref],
  );

  useEffect(() => {
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return isIntersecting;
};

export {
  useAxios,
  useOnScreen,
  useClickOutside,
  useScrollLock,
  useStores,
  useCountdown,
};
